export default __webpack_public_path__ + "static/media/logo-white.ec2e8709.svg";